import React from 'react';

export const XIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3148 4.5L13.7541 10.8536L20.2952 19.5H15.1737L11.1666 14.2554L6.57553 19.5H4.03089L9.97732 12.7018L3.7041 4.5H8.9541L12.5809 9.29464L16.7702 4.5H19.3148ZM8.18803 5.94107L17.2898 17.9786H17.2845H15.8755L6.67196 5.94107H8.18803Z"
        fill="white"
      />
    </svg>
  );
};
